// Datos de la web de Arlan. Los leads se envían a /api/leads (MongoDB).

export const IMAGES = {
  cover: "https://static.prod-images.emergentagent.com/jobs/5041eab0-26bf-4329-9668-32605c8e260d/images/4a44dd44fc1080aeae008d0c7294b6ff5ccebc7f396990e8368514e59b9c86b2.jpeg",
  hero: "https://static.prod-images.emergentagent.com/jobs/5041eab0-26bf-4329-9668-32605c8e260d/images/053908be9a63f677589cd16d09d47e0e467abb68ce884ae32bb7975692b0224a.jpeg",
  unitDetail: "https://static.prod-images.emergentagent.com/jobs/5041eab0-26bf-4329-9668-32605c8e260d/images/a7bf5795892ad7f50d99b092d2d30a48f2eb04113052d8dc861960b0778a9e17.jpeg",
  unitPlant: "https://static.prod-images.emergentagent.com/jobs/5041eab0-26bf-4329-9668-32605c8e260d/images/f83bd0c79f9c31d3c80caf7dd6ca9a27e5d2854a40d3248f9604cdbc3b5b5ead.jpeg",
  biochar: "https://static.prod-images.emergentagent.com/jobs/5041eab0-26bf-4329-9668-32605c8e260d/images/c60b1e840f2904558b326f00d5b3344201637bbfeca521a385cf3c93f3280d11.jpeg",
  drawing: "/process/machine-drawing.webp",
  machine: "https://static.prod-images.emergentagent.com/jobs/5041eab0-26bf-4329-9668-32605c8e260d/images/0a6ce844e11e15ef209c2c634782fa14bfeed824e4bcea6220b8b615d9338564.jpeg",
  dataCenter: "https://static.prod-images.emergentagent.com/jobs/5041eab0-26bf-4329-9668-32605c8e260d/images/f6ef63991af1ef54d06804fc5acc5781818107b5aaf86334df6660e6853acdf9.jpeg",
  facility: "https://images.unsplash.com/photo-1578776349090-de61da00ff1a",
  food: "https://images.unsplash.com/photo-1513828418004-7aa1c7e5c824",
  paper: "https://images.unsplash.com/photo-1705147219565-fe9f6f369d03",
  orchard: "https://images.unsplash.com/photo-1637048716718-1229686e88fd",
};

export const NAV_LINKS = [
  { id: "quienes", label: "Quiénes somos" },
  { id: "ventajas", label: "Ventajas" },
  { id: "tecnologia", label: "Tecnología" },
  { id: "agro", label: "Agricultura" },
  { id: "sectores", label: "Sectores" },
  { id: "equipo", label: "Equipo" },
  { id: "contacto", label: "Contacto" },
];

export const HERO_SLIDES = [
  { id: "energia", line1: "Building a", line2: "carbon free tomorrow", cta: "Cómo lo hacemos", target: "quienes", icon: "Leaf", video: "/video/hero.mp4", tag: "" },
  { id: "calor", line1: "Energía que", line2: "elimina CO₂", cta: "Quiero descarbonizar mi proceso", target: "tecnologia", icon: "Flame", image: "unitPlant", tag: "Energy" },
  { id: "biochar", line1: "Biochar", line2: "carbono almacenado", cta: "Quiero eliminar carbono", target: "agro", icon: "Layers", image: "biochar", tag: "Energy" },
  { id: "agri", line1: "Agricultura", line2: "regenerativa", cta: "Quiero invertir en agro carbon-free", target: "agro", icon: "Sprout", image: "orchard", tag: "Agro" },
];

export const ABOUT_POINTS = [
  { title: "Pirólisis", text: "Energía térmica para la industria que retira CO₂ y lo fija como biochar." },
  { title: "Agro", text: "Agricultura regenerativa que captura carbono en árboles y suelo." },
  { title: "A medida", text: "Cada proyecto se diseña para un cliente y un proceso concretos." },
];

export const ADVANTAGES = [
  { icon: "Flame", text: "Sustituimos gas y gasóleo por calor de proceso local", link: "Industria", target: "tecnologia" },
  { icon: "Cog", text: "Convertimos biomasa residual en energía y biochar", link: "Pirólisis", target: "tecnologia" },
  { icon: "Wind", text: "Energía que elimina CO₂ de la atmósfera: mejor que renovable", link: "Carbono eliminado", target: "quienes" },
  { icon: "Sprout", text: "Plantamos árboles frutales que capturan carbono y producen alimento", link: "Agricultura", target: "agro" },
];

export const PYRO_OUTPUTS = [
  { kind: "oil", icon: "Thermometer", title: "Calor industrial", chain: ["Aceite térmico", "Intercambiador", "Calor de proceso"] },
  { kind: "oil", icon: "CloudFog", title: "Vapor", chain: ["Aceite térmico", "Generador de vapor", "Vapor industrial"] },
  { kind: "oil", icon: "Zap", title: "Electricidad", chain: ["Aceite térmico", "ORC", "Electricidad"] },
  { kind: "oil", icon: "SlidersHorizontal", title: "Solución a medida", chain: ["Aceite térmico", "Sistema específico", "Proceso del cliente"] },
  { kind: "char", icon: "Layers2", title: "Biochar", chain: ["Carbono estable", "Suelo agrícola", "CO₂ retirado de forma permanente"] },
];

export const PYRO_INPUTS = [
  { icon: "Scissors", title: "Podas agrícolas" },
  { icon: "Wheat", title: "Restos de cosecha" },
  { icon: "Trees", title: "Biomasa forestal residual" },
];

export const MACHINE = {
  dimension: "≈ 12 m · contenedor de 40 pies",
  operated: "Instalada, operada y mantenida por Arlan",
};

export const THERMAL_FACTS = [
  { icon: "Flame", title: "Sustituye gas natural y gasóleo.", text: "Aceite térmico 180–240 °C: calor de proceso, vapor u ORC." },
  { icon: "Gauge", title: "Se integra en el circuito existente.", text: "La caldera actual queda como respaldo." },
  { icon: "Wrench", title: "Sin operación a cargo del cliente.", text: "Arlan instala, opera y mantiene; precio del calor estable." },
  { icon: "Leaf", title: "Carbono negativo, no solo renovable.", text: "Cada kWh retira CO₂, medible y certificable." },
];

export const SECTORS = [
  { title: "Alimentaria y Láctea", detail: "Vapor y escaldado", image: "food" },
  { title: "Química y Farmacéutica", detail: "Aceite térmico", image: "facility" },
  { title: "Papelera y Cartón", detail: "Secado continuo", image: "paper" },
  { title: "Centros de datos", detail: "Energía y refrigeración", image: "dataCenter" },
  { title: "Agroindustria", detail: "Secaderos", image: "unitDetail" },
];

export const STANDARDS = ["CSRD", "SBTi", "EU ETS", "EBC Biochar", "Puro.earth", "Verra"];

export const OFFICES = [
  { name: "Arlan · Pamplona", lines: ["P.º Santxiki, 1, Edif. K", "31192 Mutilva, Navarra"] },
  { name: "Arlan · Madrid", lines: ["C/ Aviador Zorita, 12", "28020 Madrid"] },
];

export const TEAM_INTRO = "Somos un equipo multidisciplinar con experiencia en ingeniería térmica, desarrollo y financiación de proyectos energéticos y gestión agrícola. Combinamos criterio técnico y visión de negocio para llevar cada proyecto del diseño a la operación.";

export const TEAM_GROUP = {
  text: "Arlan es la rama de energía y sostenibilidad de un grupo empresarial familiar con más de 40 años de trayectoria e intereses en los sectores tecnológico, industrial y alimentario.",
  years: "+40",
  caption: "años de trayectoria del grupo en los sectores tecnológico, industrial y alimentario.",
};

export const LEGAL_LINKS = [
  { label: "Aviso legal", to: "/aviso-legal" },
  { label: "Política de privacidad", to: "/privacidad" },
  { label: "Política de cookies", to: "/cookies" },
];

export const SECTOR_OPTIONS = [
  "Alimentaria y bebidas",
  "Láctea",
  "Química",
  "Farmacéutica",
  "Papelera y cartón",
  "Centros de datos",
  "Agroindustria",
  "Otra industria",
];

export const FUEL_OPTIONS = ["Gas natural", "Gasóleo", "GLP / Propano", "Fuelóleo", "Electricidad", "Otro"];

export const CONTACT = {
  email: "info@arlanpartners.com",
  linkedin: "https://www.linkedin.com/in/miguel-maria-latasa/",
};
